'use client';

import Script from 'next/script';
import useCspNonce from '@/hooks/useCspNonce';
import { TRUSTPILOT_BUSINESS_UNIT_ID } from '@/utils/constants';

// Reads the CSP nonce client-side, so must be 'afterInteractive' (not
// 'beforeInteractive', which is scheduled before hydration — too early
// for a client-read nonce). The explicit `nonce` prop is required because
// some browsers (Samsung Internet <=7.x, older Android WebView) don't
// propagate nonces through `document.currentScript`.
export default function TrustpilotWidgetScript() {
  const nonce = useCspNonce();

  if (!TRUSTPILOT_BUSINESS_UNIT_ID) return null;

  return (
    <Script
      id="trustpilot-bootstrap"
      strategy="afterInteractive"
      src="https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"
      nonce={nonce || undefined}
      onError={(e) => console.error('[TrustpilotWidgetScript] Failed to load bootstrap', e)}
    />
  );
}
